import { Component } from '@angular/core';

@Component({
  selector: 'app-calidad',
  imports: [],
  templateUrl: './calidad.html',
  styleUrl: './calidad.css',
})
export class CalidadComponent {

}
